import { render } from "./evaluationAdd.vue?vue&type=template&id=3b84569c&scoped=true"
import script from "./evaluationAdd.vue?vue&type=script&lang=js"
export * from "./evaluationAdd.vue?vue&type=script&lang=js"

import "./evaluationAdd.vue?vue&type=style&index=0&id=3b84569c&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b84569c"]])

export default __exports__